import { render } from "./RSVPpage.vue?vue&type=template&id=23773325&scoped=true"
import script from "./RSVPpage.vue?vue&type=script&lang=js"
export * from "./RSVPpage.vue?vue&type=script&lang=js"

import "./RSVPpage.vue?vue&type=style&index=0&id=23773325&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23773325"]])

export default __exports__